exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pricing-sheet-page{padding:25px 20px 20px 20px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;height:100vh;overflow:auto}.pricing-sheet-page header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;width:60%;text-align:center;gap:20px;padding:0 20px 20px 20px;font-size:16px}.pricing-sheet-page header .logo{width:100px}.pricing-sheet-page .powered-by-label{position:fixed;right:15px;bottom:10px;font-size:14px}.pricing-sheet-page .powered-by-label .registered-trademark-sign{font-size:16px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/embeddable/pricing_sheet/PricingSheetPage.scss
// module id = 752
// module chunks = 1